module.exports = __webpack_public_path__ + "static/media/icon-rx.48a69878.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-rx.svg
// module id = 957
// module chunks = 0